<template>
    <div ref="container" class="relative w-full h-full" />
</template>

<script setup lang="ts">
import { inject, onMounted, ref, watch } from "vue";
import type { AppEmitter } from "../../emitter";

const props = defineProps<{
    address?: any;
    coordinates?: any;
}>();

const emitter = inject<AppEmitter>("mitt")!;
const container = ref<HTMLElement | null>(null);
const loading = ref(true);
let location = props.coordinates;

emitter.on("googleMapsLoaded", () => {
    if (typeof google === "undefined" || typeof google.maps === "undefined") {
        return;
    }

    if (location.lat === null && location.lng === null) {
        return geolocate();
    }

    loading.value = false;
});

onMounted(() => {
    watch(
        () => loading.value,
        (isLoading) => {
            if (!isLoading) {
                drawMap();
            }
        },
    );
});

function geolocate() {
    new google.maps.Geocoder().geocode(
        {
            address: `${props.address.line1} ${props.address.line2}, ${props.address.city},
            ${props.address.state} ${props.address.postal_code}, ${props.address.country_code}`,
            componentRestrictions: {
                country: props.address.country_code,
            },
        },
        (results: any, status: any) => {
            if (status === "OK") {
                location = results[0].geometry.location;
                loading.value = false;
            }
        },
    );
}

function drawMap() {
    const map = new google.maps.Map(container.value, {
        zoom: 15,
        center: location,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
    });

    new google.maps.Marker({
        map,
        draggable: false,
        animation: google.maps.Animation.DROP,
        position: location,
    });
}
</script>
